import { computed, watch, onUnmounted } from "vue";
import { useStore } from "vuex";
import { notaryHeartbeat } from "@/entities/session/api/notaries";

const HEARTBEAT_MS = 5 * 60 * 1000;

export function useNotaryHeartbeat() {
  const store = useStore();
  let timer = null;

  const isNotary = computed(() => !!store.getters.get_notary?.uuid);

  const tick = () => {
    notaryHeartbeat().catch(() => {});
  };

  const stop = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  watch(
    isNotary,
    (active) => {
      stop();
      if (active) {
        tick();
        timer = setInterval(tick, HEARTBEAT_MS);
      }
    },
    { immediate: true }
  );

  onUnmounted(stop);
}
